export enum TabIndex {
  None = -1,
  Usual = 0,

  ContinueButton = 0,
  SummaryPopover = 0,

  CloseButton = 20,
}
